module.exports = __webpack_public_path__ + "static/img/25.adb54f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/aboutUs/images/25.png
// module id = 6fX8
// module chunks = 0